import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ToastService } from '../../Util/Toast/toast.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-view-document-detail',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, LoaderComponent, DataTablesModule],
  templateUrl: './view-document-detail.component.html',
  styleUrl: './view-document-detail.component.scss'
})
export class ViewDocumentDetailComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  public User: any = null;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();
  DocumentDetails: any[] = []
  Filter = {
    DocumentNo: null,
    IssueDate: null,
    Branch: null,
    IssueType: null
  }
  dtoptions: DataTables.Settings = {};
  constructor(public activeModal: NgbActiveModal,
    private toast: ToastService,
    private support: SupportTicketService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sessionService: SessionService,
    private utility: UtilityService,
    private download: DownloadSampleService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  getData() {
    this.isDisabled = true;
    this.support.ESS_Uniform({ SelectType: '2', EmpMasterId: this.InputData.EmpMasterId, DocumentNo: this.InputData.DocumentNo }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Filter.DocumentNo = response.Table[0].DocumentNo;
          this.Filter.IssueDate = response.Table[0].IssueDate;
          this.Filter.Branch = response.Table[0].Branch;
          this.Filter.IssueType = response.Table[0].IssueType;
          this.DocumentDetails = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }

  Cancel() {
    this.activeModal.close();
  }

}
